<script lang="ts">
  import { Header } from '@smui/dialog';
  import { createEventDispatcher } from 'svelte';
  import { getAppConfig } from '../../../common/config/app-config';
  import { getStr, isMobile } from '../../../common/util';
  import { isAddToCartDisabled, isPreOrderDisabled } from '../services/pdp-data-services';
  import {
    currentSelectedStoreData,
    joodPrimePriceData,
    pdpProductExtraLinksData,
    pdpTitleData,
    productPriceData,
    productTasheelPriceData,
  } from '../store/pdp_store';
  import ProductTasheelPrice from './DigitalGiftCardProduct/ProductTasheelPrice.svelte';
  import ExtraProductTitle from './ExtraProductTitle.svelte';
  import JoodPrimePrice from './JoodPrimePrice.svelte';
  import PdpButton from './PdpButton.svelte';
  import PdpQuantityModifier from './PdpQuantityModifier.svelte';
  import ProductExtraLinks from './ProductExtraLinks.svelte';
  import ProductPrice from './ProductPrice.svelte';

  export let data: any;
  export let preorder: boolean = false;
  const cfsInStock =
    $currentSelectedStoreData?.stockLevelStatus?.code === 'inStock' ||
    $currentSelectedStoreData?.stockLevelStatus?.code === 'lowStock';
  const dispatcher = createEventDispatcher();

  function addToCart() {
    dispatcher('addToCart', null);
  }

  const { primeEnabled, primeLevel, benefitType } = getAppConfig();
  const disabledAddToCartBtn = isAddToCartDisabled(data, cfsInStock);
  let disabledPreOrderBtn = isPreOrderDisabled(data);
</script>

<div class="pdp-details-story-dialog">
  <Header>
    <div class="d-flex product-image-and-title">
      <div class="product-image-and-title-img">
        {#if isMobile()}
          <img src="{data?.amplienceProductBaseUrl}&w=48&h=48" alt={data?.name} />
        {:else}
          <img src="{data?.amplienceProductBaseUrl}&w=55&h=65" alt={data?.name} />
        {/if}
      </div>

      <ExtraProductTitle data={$pdpTitleData} />
    </div>
    {#if data?.isComingSoon != true}
      {#if benefitType === 'DISCOUNT' && primeEnabled && primeLevel && ((primeLevel === 'VIPPRIME' && data?.vipPrimePrice > 0) || (primeLevel === 'SMARTPRIME' && data?.smartPrimePrice > 0) || (primeLevel === 'BASICPRIME' && data?.basicPrimePrice > 0))}
        <JoodPrimePrice showDiscountUp={false} data={$joodPrimePriceData} />
      {:else if data?.isDigitalGiftCard === true}
        <ProductTasheelPrice data={$productTasheelPriceData} />
      {:else}
        <ProductPrice showDiscountUp={false} data={$productPriceData} />
      {/if}
    {/if}
    <div class="sticky-actions">
      <ProductExtraLinks data={$pdpProductExtraLinksData} />
      {#if data?.stock.stockLevelStatus.code == 'inStock' || data?.stock.stockLevelStatus.code == 'lowStock'}
        <div class="d-flex add-to-cart-container">
          {#if data?.isAddToCartEnabled}
            {#if !preorder}
              <PdpQuantityModifier
                containerClass="sticky-bar"
                displayQtyModifier={data?.productStatus === 'PRE_ORDER' ? !disabledPreOrderBtn : !disabledAddToCartBtn}
              />
            {/if}
            <div class="d-flex cart-action-buttons">
              {#if (data?.stock.stockLevelStatus.code === 'inStock' || data?.stock.stockLevelStatus.code === 'lowStock') && data?.productStatus === 'PRE_ORDER'}
                <PdpButton
                  productCode={data?.productCode}
                  label={getStr('extra.preorderbutton')}
                  type="secondary"
                  variant="solid"
                  size="large"
                  width="216px"
                  disabled={disabledPreOrderBtn}
                  on:click={() => addToCart()}
                />
              {:else}
                <PdpButton
                  label={getStr('extra.addtocartbutton')}
                  productCode={data?.productCode}
                  type="secondary"
                  variant="solid"
                  size="large"
                  width="216px"
                  disabled={disabledAddToCartBtn}
                  on:click={() => addToCart()}
                />
              {/if}
            </div>
          {/if}
        </div>
      {/if}
    </div>
  </Header>
</div>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  :global {
    .pdp-details-story-dialog {
      background-color: $primary-white !important;
    }

    .pdp-details-story-dialog .mdc-dialog__header {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      margin: 0;
      padding: 16px 16px 28px !important;
      .product-image-and-title {
        align-items: flex-start;
        @include desktop-min-width {
          flex-basis: 33%;
          padding-right: 24px;
        }
        img {
          padding: 0;
        }
      }
      .product_price {
        padding: 0 0 0 5.5rem;
        flex: 2;
      }
      .product_title {
        background-color: $primary-white;
        padding: 0;
        .brand-name {
          font-weight: 700;
          font-size: 14px;
          line-height: 16px;
        }
        .product-name {
          font-weight: 600;
          font-size: 16px;
          line-height: 18px;
        }
      }
      .product-image-and-title {
        @include desktop-min-width {
        }
      }
      @include desktop-min-width {
        align-items: center !important;
        justify-content: space-between;
        flex-wrap: nowrap;
        padding: 16px 48px !important;
        .product_title {
          padding: 0;
        }
        .product_price {
          padding: 0;
        }
        .product-image-and-title {
          align-items: center;
          .product-image-and-title-img {
            width: 80px;
            margin-right: 12px;
          }
        }
      }
    }

    .pdp-details-story-dialog {
      z-index: 9999 !important;
    }

    .mdc-button--raised {
      &.mdc-ripple-upgraded {
        margin-right: 0;
        padding: 10px 24.5px !important;
      }
    }
    .mdc-button__label {
      white-space: nowrap;
      font-size: 12px;
      line-height: 14px;
      @include desktop-min-width {
        font-size: 14px;
        line-height: 16px;
      }
    }
    .pdp-details-story-dialog .mdc-ripple-upgraded::before {
      background-color: $primary-white !important;
    }
    .pdp-details-story-dialog .mdc-ripple-upgraded::after {
      background-color: $primary-white !important;
    }
    .pdp-details-story-dialog .mdc-ripple-upgraded::hover {
      background-color: $primary-white !important;
    }

    .pdp-details-story-dialog {
      .product-key-specifications-container .card-display {
        overflow-x: scroll !important;
        @include desktop-min-width {
          overflow-x: auto !important;
        }
      }
      .cart-action-buttons {
        .button-div:first-child {
          margin-right: 16px;
          @include desktop-max-width {
            width: 157px;
          }
        }
        .button-div button {
          min-height: auto !important;
          font-size: 14px !important;
          line-height: 16px !important;
        }
      }
    }
  }

  .sticky-actions {
    display: flex;
    flex-direction: column;
    width: 100%;
    @include desktop-min-width {
      width: auto;
      align-items: center;
    }
  }

  .add-to-cart-container {
    justify-content: space-between;
    align-items: center;
    padding: 0 0 0 55px;
    margin: 15px 0 0 0;
    width: 100%;
    @include desktop-min-width {
      justify-content: center;
      padding: 0;
      margin: 0;
      width: auto;
    }
    .add-to-wish-list {
      width: 50%;
      flex-basis: 50%;
      display: block;
      margin-right: 16px;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      color: $icon-only-icon-blue;
    }
  }
  * :global(.solo-paper) {
    display: flex;
    align-items: center;
    flex-grow: 1;
    max-width: 600px;
    margin: 0 12px;
    padding: 0 12px;
    height: 48px;
  }
  * :global(.solo-paper > *) {
    display: flex;
    justify-content: space-between;
    margin: 0 12px;
  }
  * :global(.solo-input) {
    flex-grow: 1;
    color: var(--mdc-theme-on-surface, #000);
  }
  * :global(.solo-input::placeholder) {
    color: var(--mdc-theme-on-surface, #000);
    opacity: 0.6;
  }
</style>
